import { styled, Text } from '@obvio/app'
import { Button } from '@obvio/ui'

import { CenteredSection } from '@/components/CenteredSection'

export const Position = styled.dialog`
  all: unset;
  position: fixed;
  z-index: 2;
  inset: 0;
  overflow: auto;
`

export const ExitButton = styled(Button)`
  position: absolute;
  top: ${(theme) => theme.spacing.medium};
  right: ${(theme) => theme.spacing.medium};
`

export const Section = styled(CenteredSection)`
  height: 100%;
`

export const InfoText = styled(Text)`
  max-width: 27.5625rem;
  width: 100%;
  margin: 0 auto;
`

export const StyledSection = styled(Section)`
  display: grid;
  grid-template-rows: 1fr auto;
  grid-template-columns: 1fr;
  min-height: 100vh;
`
